// 购物车计算商品总价价格和附加项
// 需要传全部Sku平铺
import { COUNTRY } from '@/global'
import { calcAdt } from '@/util/calcAdt'
export default (
  skulist: any[],
  countryCode?: COUNTRY
): Promise<void[]> => {
  const spuMap: any = {}
  // 记录选中的sku数量
  const skuMap: any = {}
  skulist.forEach((item: any) => {
    // 区分字段名
    item.buyQuantity = item.orderQuantity - (item?.remainCombinationQuantity ?? 0) - (item?.stockNum ?? 0)
    const {
      productCode,
      cartId,
      productPriceLadderList,
      buyQuantity,
      minOrderQuantity,
      noPriceLadder,
      productSku
    } = item
    if (!productCode) return
    if (!spuMap[productCode]) {
      spuMap[productCode] = {
        productPriceLadderList,
        minOrderQuantity,
        count: 0,
        liveCount: 0,
        noPriceLadder
      }
    }
    if (!skuMap[productSku]) {
      skuMap[productSku] = {
        // 剔除直播商品的数量
        liveCount: 0
      }
    }
    spuMap[productCode].count += buyQuantity
    spuMap[productCode].liveCount += item.livePriceFlag ? 0 : buyQuantity ?? 0
    skuMap[productSku].liveCount += item.livePriceFlag ? 0 : buyQuantity ?? 0
  })
  Object.values(spuMap).forEach((spu: any) => {
    if (spu.productPriceLadderList?.length && spu.livePriceFlag !== 1 && !spu.noPriceLadder) {
      spu.productPriceLadderList.forEach(({ count, price }: any) => {
        if (spu.liveCount >= count) {
          spu.price = price
        }
      })
      if (!spu.price) {
        spu.price = spu.productPriceLadderList[0].price
      }
    }
  })
  return Promise.all(
    skulist.map((item: any) => {
      item.buyQuantity = item.orderQuantity - (item?.remainCombinationQuantity ?? 0) - (item?.stockNum ?? 0)
      const spu = spuMap[item.productCode] ?? {}
      const skuCount = skuMap[item.productSku]?.liveCount ?? 0
      // 是否满足起订量
      const isMeetMinimum = spu?.count ? (spu?.count >= spu.minOrderQuantity) : true
      // 只有在发到库存才验证起订量
      // 注意:如果子商品匹配了落单数量，会存在 buyQuantity 为 0 的情况，这时候不需要验证起订量
      if (spu && item.buyQuantity > 0) {
        item.lack = spu.count < spu.minOrderQuantity
      } else {
        item.lack = false
      }
      // 商品一件代发不校验起订量
      if (item.isOnePsale) {
        item.lack = false
      }
      // 囤货 购买数量不是一手数量的倍数时提示
      if (item.buyQuantity > 0 && (skuCount % (item.batchNumber || 1) > 0)) {
        item.handLack = true
      } else {
        item.handLack = false
      }
      // 直播商品不取区间价
      item.price = item.livePriceFlag === 1 ? item.productSellPrice : (!isMeetMinimum && item.isOnePsale) ? item.consignPrice : spu?.price ?? item.productSellPrice
      item.totalPrice = item.price * item.buyQuantity
      item.valuePrice = item.price * item.buyQuantity
      const paymentDetail = JSON.parse(item.paymentDetail as string || '[]')
      // 计算组合商品账期价格
      if (paymentDetail?.length) {
        item.curPdtPirce = Number((item.totalPrice * paymentDetail[0].paymentPeriod).toFixed(2))
      } else {
        item.curPdtPirce = item.totalPrice
      }
      // 计算附加费
      return calcAdt(item, countryCode).then((res) => {
        item.adtPrice = res ?? 0
      })
    })
  )
}
